import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { useTranslation } from "context/TranslationProvider";

const DeleteModal = ({
  isOpen,
  toggle,
  itemName = "item",
  onDelete,
  loading = false,
}) => {
  const { t } = useTranslation();
  const entityLabel = itemName !== "default" ? itemName : t("entity.default", "item");
  const message = t(`modal.deleteModal.${itemName}`) || t("modal.deleteModal.default", "Are you sure you want to delete this item?");

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle} className="border">
        {t(`modal.deleteModal.${entityLabel}`) || t("modal.deleteModal.title", "Delete")}
      </ModalHeader>

      <ModalBody>
        <p className="mb-2">{message}</p>
        <p className="text-muted mb-0">
          {t("modal.deleteModal.body", "This action cannot be undone.")}
        </p>
      </ModalBody>

      <ModalFooter className="border">
        <Button color="secondary" onClick={toggle}>
          {t("common.cancel", "Cancel")}
        </Button>

        <Button color="danger" onClick={onDelete} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              {t("table.row.remove", "Delete")}
            </>
          ) : (
            t("table.row.remove", "Delete")
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
